export default "__VITE_ASSET__C9zKJ8od__"